var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: _vm.formData.id ? "修改球队" : "添加球队",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "label-width": "100px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "name", label: "名称" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.formData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "name", $$v)
                  },
                  expression: "formData.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "age_group", label: "年龄组" }
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.formData.age_group,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "age_group", $$v)
                    },
                    expression: "formData.age_group"
                  }
                },
                _vm._l(_vm.ageGroupList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.age_group, value: item.age_group }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "can_register", label: "是否可报名" }
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.formData.can_register,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "can_register", $$v)
                    },
                    expression: "formData.can_register"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("是")
                  ]),
                  _c("el-radio", { attrs: { label: 0, border: "" } }, [
                    _vm._v("否")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "registration_fee", label: "报名费用" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.formData.registration_fee,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "registration_fee", $$v)
                  },
                  expression: "formData.registration_fee"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { label: "球队logo", prop: "logo" }
            },
            [
              _c("uploadImage", {
                attrs: { value: _vm.imgList },
                on: { input: _vm.imgChange }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { prop: "location_name", label: "场地" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: {
                  disabled: "",
                  autocomplete: "off",
                  placeholder: "请输入"
                },
                model: {
                  value: _vm.formData.location_name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "location_name", $$v)
                  },
                  expression: "formData.location_name"
                }
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "15px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addLocation.init()
                    }
                  }
                },
                [_vm._v("更换关联场地")]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { prop: "introduction", label: "简介" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: {
                  type: "textarea",
                  placeholder: "请填写",
                  autocomplete: "off"
                },
                model: {
                  value: _vm.formData.introduction,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "introduction", $$v)
                  },
                  expression: "formData.introduction"
                }
              })
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { prop: "" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addContent }
                    },
                    [_vm._v("添加特色")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._l(_vm.formData.team_vibe, function(domain, index) {
            return _c(
              "div",
              { key: index + "k", staticClass: "param_keysClass" },
              [
                _c(
                  "div",
                  { staticClass: "lodingItem-operationFrame flex" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "team_vibe." + index + ".value",
                          rules: _vm.rules.value,
                          "label-width": "60px"
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "operationFrame-entity",
                          attrs: { clearable: "", placeholder: "请输入" },
                          model: {
                            value: domain.value,
                            callback: function($$v) {
                              _vm.$set(domain, "value", $$v)
                            },
                            expression: "domain.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-button", {
                      staticStyle: { margin: "0 10px 24px 10px" },
                      attrs: {
                        size: "mini",
                        type: "danger",
                        circle: "",
                        icon: "el-icon-delete"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.removeContent(domain)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          })
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "200px" },
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      ),
      _c("addLocation", {
        ref: "addLocation",
        on: { change: _vm.changeLocation }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }